import { render } from "./objection.vue?vue&type=template&id=648d376f&scoped=true"
import script from "./objection.vue?vue&type=script&lang=js"
export * from "./objection.vue?vue&type=script&lang=js"

import "./objection.vue?vue&type=style&index=0&id=648d376f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-648d376f"

export default script